/**
 * Opciones de período compartidas entre módulos Analytics.
 * @sync-with config/analytics-config.js PERIOD_OPTIONS (Leads)
 */
export const MODULE_PERIOD_OPTIONS = [
  { key: 'all', label: 'Todos' },
  { key: 'today', label: 'Hoy' },
  { key: 'yesterday', label: 'Ayer' },
  { key: 'last_7_days', label: 'Últimos 7 días' },
  { key: 'last_30_days', label: 'Últimos 30 días' },
  { key: 'current_month', label: 'Este mes' },
  { key: 'previous_month', label: 'Mes anterior' },
  { key: 'last_90_days', label: 'Últimos 90 días' },
  { key: 'current_year', label: 'Año actual' }
];

function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function addDays(d, n) {
  const x = startOfDay(d);
  x.setDate(x.getDate() + n);
  return x;
}

/** @returns {{dateFrom:string, dateTo:string}} */
export function resolveModulePeriodRange(periodKey) {
  const key = periodKey || 'last_30_days';
  const now = new Date();
  const end = startOfDay(now);
  let start = startOfDay(now);

  if (key === 'today') {
    start = startOfDay(now);
  } else if (key === 'yesterday') {
    const y = addDays(startOfDay(now), -1);
    return { dateFrom: ymd(y), dateTo: ymd(y) };
  } else if (key === 'all') {
    return { dateFrom: '2020-01-01', dateTo: ymd(end) };
  } else if (key === 'last_7_days') {
    start = startOfDay(new Date(now.getTime() - 6 * 86400000));
  } else if (key === 'last_30_days') {
    start = startOfDay(new Date(now.getTime() - 29 * 86400000));
  } else if (key === 'last_90_days') {
    start = startOfDay(new Date(now.getTime() - 89 * 86400000));
  } else if (key === 'current_month') {
    start = new Date(now.getFullYear(), now.getMonth(), 1);
  } else if (key === 'previous_month') {
    start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastPrev = new Date(now.getFullYear(), now.getMonth(), 0);
    return { dateFrom: ymd(start), dateTo: ymd(lastPrev) };
  } else if (key === 'current_year') {
    start = new Date(now.getFullYear(), 0, 1);
  } else if (key === 'custom') {
    return { dateFrom: '', dateTo: '' };
  }

  return { dateFrom: ymd(start), dateTo: ymd(end) };
}

/**
 * Período comparable de igual duración (cliente; el GAS recalcula igual).
 * @param {string} dateFrom
 * @param {string} dateTo
 */
export function resolveComparablePriorRange(dateFrom, dateTo) {
  const from = new Date(String(dateFrom) + 'T12:00:00');
  const to = new Date(String(dateTo) + 'T12:00:00');
  if (isNaN(from.getTime()) || isNaN(to.getTime()) || to < from) return null;
  const days = Math.round((to - from) / 86400000) + 1;
  const priorTo = addDays(from, -1);
  const priorFrom = addDays(priorTo, -(days - 1));
  return { dateFrom: ymd(priorFrom), dateTo: ymd(priorTo), days };
}
